import { InternalAccessor, Table } from '@billy/design-system'
import { ReactElement, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { DeliveryNote } from '@features/deliveryNotes/types/deliveryNote'

import { useDeliveryNotesListColumns } from './hooks/useDeliveryNotesListColumns'

interface DeliveryNotesListProps {
  deliveryNotes: DeliveryNote[]
  isError: boolean
  isLoading: boolean
}

export const DeliveryNotesList = ({ deliveryNotes, isError, isLoading }: DeliveryNotesListProps): ReactElement => {
  const { t } = useTranslation()
  const { columns } = useDeliveryNotesListColumns()

  const emptyRowInfo = isError ? t('delivery_notes.table.could_not_load') : undefined

  const data = useMemo(
    () => deliveryNotes.map((deliveryNote) => ({ ...deliveryNote, [InternalAccessor.StaticActions]: true })),
    [deliveryNotes],
  )

  return (
    <Table
      columns={columns}
      data={data}
      emptyRowInfo={emptyRowInfo}
      isClientSidePagination
      isLoading={isLoading}
      withSkeletonView
      withStickyHeader
    />
  )
}
